export default __webpack_public_path__ + "static/media/addProduct.c031d76d.svg";